export default __webpack_public_path__ + "f650f111a3b890d116f1ba740b7e3de3.woff2";